import '../../assets/index25.css';var q = Object.defineProperty, D = Object.defineProperties;
var X = Object.getOwnPropertyDescriptors;
var i = Object.getOwnPropertySymbols;
var P = Object.prototype.hasOwnProperty, F = Object.prototype.propertyIsEnumerable;
var g = (t, e, a) => e in t ? q(t, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[e] = a, p = (t, e) => {
  for (var a in e || (e = {}))
    P.call(e, a) && g(t, a, e[a]);
  if (i)
    for (var a of i(e))
      F.call(e, a) && g(t, a, e[a]);
  return t;
}, I = (t, e) => D(t, X(e));
var $ = (t, e) => {
  var a = {};
  for (var r in t)
    P.call(t, r) && e.indexOf(r) < 0 && (a[r] = t[r]);
  if (t != null && i)
    for (var r of i(t))
      e.indexOf(r) < 0 && F.call(t, r) && (a[r] = t[r]);
  return a;
};
import { jsx as n } from "react/jsx-runtime";
import { forwardRef as j, useState as f, useRef as C, useEffect as K } from "react";
import { SearchFarFAIcon as N, XMarkFarFAIcon as L } from "../Icons/index.js";
import { Button as w } from "../Button/index.js";
import { T as R } from "../../index-eVpm_et2.js";
import { I as M } from "../../Input--FNE961U.js";
import { F as Q } from "../../Flex-BcSdq2bJ.js";
const W = "SearchBar-module__wrapper___BqBZQ", Z = "SearchBar-module__standalone___3Lkhr", G = "SearchBar-module__standaloneExpanded___px1WR", J = "SearchBar-module__table___IBgP8", O = "SearchBar-module__tableExpanded___HTKXH", U = "SearchBar-module__leftSectionParent___bHuV1", Y = "SearchBar-module__rightSectionParent___fqRcu", ee = "SearchBar-module__leftSection___Sku1g", te = "SearchBar-module__rightSection___2rVCI", ae = "SearchBar-module__section___zrDsI", re = "SearchBar-module__input___gvTwC", o = {
  wrapper: W,
  standalone: Z,
  standaloneExpanded: G,
  table: J,
  tableExpanded: O,
  leftSectionParent: U,
  rightSectionParent: Y,
  leftSection: ee,
  rightSection: te,
  section: ae,
  input: re
}, ne = j((le, v) => {
  var m = le, {
    placeholder: t = "Search...",
    onChange: e,
    defaultValue: a = "",
    value: r,
    onClick: d,
    variant: s = "default",
    className: oe
  } = m, T = $(m, [
    "placeholder",
    "onChange",
    "defaultValue",
    "value",
    "onClick",
    "variant",
    "className"
  ]);
  const [y, S] = f(a), [A, h] = f(!1), [b, B] = f(!1), V = C(null), c = v || V;
  K(() => {
    b && c && c.current && ([0, 50, 100, 200].forEach((E) => {
      setTimeout(() => {
        c.current && (c.current.focus(), console.log(`Focus attempt at ${E}ms`));
      }, E);
    }), B(!1));
  }, [b, c]);
  const _ = r !== void 0 ? r : y, u = s === "standalone" || s === "table", k = (l) => {
    r === void 0 && S(l), e == null || e(l);
  }, z = (l) => {
    l.preventDefault(), l.stopPropagation(), r === void 0 && S(""), e == null || e(""), B(!0);
  }, x = () => {
    u && h(!0), d == null || d();
  }, H = () => {
    u && !_ && h(!1);
  };
  return u && !A ? /* @__PURE__ */ n("div", { className: s === "table" ? o.table : o.standalone, children: /* @__PURE__ */ n(R, { label: "Search", position: "bottom", children: /* @__PURE__ */ n(
    w,
    {
      variant: "tertiary",
      size: "sm",
      onClick: x,
      "aria-label": "Search",
      children: /* @__PURE__ */ n(N, {})
    }
  ) }) }) : /* @__PURE__ */ n(
    "div",
    {
      className: `${o.wrapper} ${s === "standalone" ? `${o.standalone} ${o.standaloneExpanded}` : s === "table" ? `${o.table} ${o.tableExpanded}` : ""}`,
      children: /* @__PURE__ */ n(
        M,
        p({
          ref: c,
          classNames: I(p({}, o), {
            section: o.section,
            wrapper: `${o.leftSectionParent} ${o.rightSectionParent}`
          }),
          placeholder: t,
          value: _,
          onChange: (l) => k(l.currentTarget.value),
          onClick: x,
          onBlur: H,
          leftSection: /* @__PURE__ */ n("div", { className: o.leftSection, children: /* @__PURE__ */ n(N, {}) }),
          rightSection: /* @__PURE__ */ n("div", { className: o.rightSection, children: _ && /* @__PURE__ */ n(Q, { align: "center", gap: "xxs", children: /* @__PURE__ */ n(R, { label: "Clear", position: "bottom", children: /* @__PURE__ */ n(
            w,
            {
              variant: "tertiary",
              size: "sm",
              onClick: (l) => z(l),
              "aria-label": "Clear",
              children: /* @__PURE__ */ n(L, {})
            }
          ) }) }) }),
          "aria-label": "Search"
        }, T)
      )
    }
  );
});
ne.displayName = "SearchBar";
export {
  ne as SearchBar
};
